// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"3c8cd918","239":"4f714809","453":"03b07586","455":"3c566fc4","977":"1878e56b"}[chunkId] + ".chunk.js";
};